import { Button, Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Logo from "../../../src/assets/images/PoweredNew.png";
import userServiceApi from "../../api/userServiceApi";
import backBtn from "../../assets/images/back-arrow.svg";
import { toast } from "react-toastify";
export default function ResetPasswordForm() {
  const param = useParams();

  const token = param.token;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)

  const handleReset = async (values) => {
    try {
      if (values && values.newPassword === values.confirmPassword) {
        setLoading(true)
        const response = await fetch(userServiceApi.resetPassword(token), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ newPassword: values.newPassword }),
        });

        if (response.ok) {
          navigate("/PartnerAdmin");
        } else {
          const res = await response.json()
          toast.error(res.message)
        }
      }
    } catch (error) {
      console.log('Error in reset password:', error);
    }
    finally {
      setLoading(false)
    }
  }

  return (
    <div className="tabContainer">
      <div className="main-container" style={{ paddingTop: "5px" }}>
        <div className="header-container">
          <div className="backbtn-container">
            <img src={backBtn}
              onClick={() => navigate('/PartnerAdmin')}
              alt="" />
            <p>Create Password</p>
          </div>
        </div>
        <div className="formInfoStyle changePassword">
          <Form
            name="control-hooks"
            className="organizationForm"
            form={form}
            autoComplete="off"
            onFinish={handleReset}
          >
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  name="newPassword"
                  label="New Password"
                  hasFeedback
                  rules={[
                    { required: true, message: 'Please input your new password!' },
                    { min: 8, message: 'Password must be at least 8 characters long!' },
                    {
                      // pattern need to be changed in both partner and org admins
                      pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?!.*\s)/,
                      message: 'Password must include uppercase, lowercase, number, special character and must not contain spaces!',
                    },
                  ]}
                >
                  <Input.Password required={true} placeholder="New Password" />
                </Form.Item>
              </div>
            </div>
            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item
                  name="confirmPassword"
                  label="Confirm Password"
                  dependencies={['newPassword']}  // Add dependencies to revalidate when 'newPassword' changes
                  hasFeedback  // Provides feedback to the user as they type
                  rules={[
                    { required: true, message: 'Please input your new password!' },
                    // { min: 8, message: 'Password must be at least 8 characters long!' },
                    // {
                    //   pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                    //   message: 'Password must include uppercase, lowercase, number, and special character!',
                    // }, 
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Passwords do not match'));
                      },
                    }),
                  ]}
                >
                  <Input.Password required={true} placeholder="Confirm Password" />
                </Form.Item>
              </div>
            </div>

            <div className="formInfoRow">
              <div className="formInfoCol">
                <Form.Item label=" " colon={false}>
                  <div className="form-btn-container" >
                    <Button className="form-save-btn" onClick={() => form.submit()}>
                      Save
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div >
  );
}
